import { stdObject } from "../data/types/stdObject";

export const reorderHeaders = (list: stdObject[]) => {
  let tempHeaders: stdObject = {};
  list.forEach((e: any) => {
    if (!tempHeaders[e.GRUCAB]) {
      tempHeaders[e.GRUCAB] = {
        default: list.filter(
          (o: any) => o.GRUCAB === e.GRUCAB && o.USUCAB === 0,
        ),
        user: list.filter((o: any) => o.GRUCAB === e.GRUCAB && o.USUCAB !== 0),
      };
    }
  });
  return tempHeaders;
};
